"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncDownloadWatcher = asyncDownloadWatcher;

var _effects = require("redux-saga/effects");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var modalActions = _interopRequireWildcard(require("../../../modal/actions"));

var _apiRequest = require("../../api/apiRequest");

var _Utils = _interopRequireDefault(require("../../../../utils/Utils"));

var _selectors = require("../../../locale/selectors");

var modalTypes = _interopRequireWildcard(require("../../../modal/types"));

var _modalTypes = require("../../../../constants/modalTypes");

var _selectors2 = require("./selectors");

var _urls = require("../../../../constants/urls");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(abortDownload),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(checkDownloadStatus),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(downloadWorker),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(asyncDownloadWatcher);

var downloadController = null;

function abortDownload() {
  return regeneratorRuntime.wrap(function abortDownload$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)(actions.abort());

        case 2:
          if (downloadController) {
            downloadController.abort();
          }

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function checkDownloadStatus(action) {
  var _action$payload, exportKey, fileUUID, isFetching, locale, status, fileInfo, isAborted;

  return regeneratorRuntime.wrap(function checkDownloadStatus$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload = action.payload, exportKey = _action$payload.exportKey, fileUUID = _action$payload.fileUUID;

        case 2:
          if (!true) {
            _context2.next = 37;
            break;
          }

          _context2.next = 5;
          return (0, _effects.delay)(2000);

        case 5:
          _context2.next = 7;
          return (0, _effects.select)(_selectors2.getIsFetching);

        case 7:
          isFetching = _context2.sent;

          if (isFetching) {
            _context2.next = 10;
            break;
          }

          return _context2.abrupt("break", 37);

        case 10:
          _context2.next = 12;
          return (0, _effects.select)(_selectors.getLocale);

        case 12:
          locale = _context2.sent;
          _context2.next = 15;
          return (0, _effects.call)(_apiRequest.apiRequest, _urls.DOWNLOAD_URLS.DOWNLOAD_STATUS, "GET", {
            query: {
              exportKey: exportKey,
              uuid: fileUUID
            },
            locale: locale
          });

        case 15:
          status = _context2.sent;

          if (!status) {
            _context2.next = 35;
            break;
          }

          _context2.next = 19;
          return (0, _effects.put)(actions.setStatus(status));

        case 19:
          if (!(status.info !== null)) {
            _context2.next = 22;
            break;
          }

          _context2.next = 22;
          return (0, _effects.put)(modalActions.setText(status.info));

        case 22:
          fileInfo = status.asyncFileInfo;

          if (!fileInfo) {
            _context2.next = 33;
            break;
          }

          if (!(fileInfo.uuid === null || fileInfo.error)) {
            _context2.next = 28;
            break;
          }

          throw new Error("error during file " + fileUUID + " processing");

        case 28:
          if (!fileInfo.ready) {
            _context2.next = 31;
            break;
          }

          _context2.next = 31;
          return (0, _effects.put)(actions.setReady());

        case 31:
          _context2.next = 35;
          break;

        case 33:
          _context2.next = 35;
          return (0, _effects.put)(actions.failure());

        case 35:
          _context2.next = 2;
          break;

        case 37:
          _context2.next = 50;
          break;

        case 39:
          _context2.prev = 39;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 43;
          return (0, _effects.select)(_selectors2.getIsAborted);

        case 43:
          isAborted = _context2.sent;

          if (isAborted) {
            _context2.next = 50;
            break;
          }

          console.error(_context2.t0);
          _context2.next = 48;
          return (0, _effects.put)(modalActions.show("error/errorMessage", _context2.t0.message, _modalTypes.MODAL_TYPES.ERROR));

        case 48:
          _context2.next = 50;
          return (0, _effects.put)(actions.failure());

        case 50:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 39]]);
}

function downloadWorker(action) {
  var _action$payload2, url, filterParams, comparison, _action$payload2$meth, method, locale, queryString, downloadUrl, asyncResultResponse, fileUUID, _ref, success, failure, abort, response, headerLine, nameFromResponse, startFileNameIndex, endFileNameIndex, fileName, data, _url, link, isAborted;

  return regeneratorRuntime.wrap(function downloadWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload2 = action.payload, url = _action$payload2.url, filterParams = _action$payload2.filterParams, comparison = _action$payload2.comparison, _action$payload2$meth = _action$payload2.method, method = _action$payload2$meth === void 0 ? "POST" : _action$payload2$meth;
          downloadController = new AbortController(); // Start download

          _context3.next = 5;
          return (0, _effects.put)(actions.start());

        case 5:
          _context3.next = 7;
          return (0, _effects.put)(modalActions.show('view/fileDownloadStarted/title', 'view/fileDownloadStarted/text', null, 'buttons/cancel'));

        case 7:
          _context3.next = 9;
          return (0, _effects.select)(_selectors.getLocale);

        case 9:
          locale = _context3.sent;
          queryString = _Utils["default"].buildQueryString({
            exportKey: filterParams.exportKey,
            reportId: filterParams.reportId,
            comparison: comparison
          });
          downloadUrl = "".concat(url).concat(queryString); // Request download

          _context3.next = 14;
          return (0, _effects.call)(_apiRequest.apiRequest, downloadUrl, method, {
            body: method === 'POST' ? filterParams : undefined,
            locale: locale,
            timeout: 0
          }, downloadController.signal);

        case 14:
          asyncResultResponse = _context3.sent;
          fileUUID = asyncResultResponse.uuid; // Begin check status

          if (!filterParams.exportKey) {
            _context3.next = 19;
            break;
          }

          _context3.next = 19;
          return (0, _effects.put)(actions.sagaStatus(filterParams.exportKey, fileUUID));

        case 19:
          _context3.next = 21;
          return (0, _effects.race)({
            success: (0, _effects.take)(types.SET_READY),
            failure: (0, _effects.take)(types.FAILURE),
            abort: (0, _effects.take)(types.ABORT)
          });

        case 21:
          _ref = _context3.sent;
          success = _ref.success;
          failure = _ref.failure;
          abort = _ref.abort;

          if (!(failure || abort)) {
            _context3.next = 27;
            break;
          }

          return _context3.abrupt("return");

        case 27:
          _context3.next = 29;
          return (0, _effects.call)(_apiRequest.apiRequest, _urls.DOWNLOAD_URLS.ASYNC_FILE_DOWNLOAD + fileUUID, "GET", downloadController.signal);

        case 29:
          response = _context3.sent;
          // Parse response
          headerLine = response.headers.get('content-disposition');

          if (headerLine) {
            startFileNameIndex = headerLine.indexOf('"') + 1;
            endFileNameIndex = headerLine.lastIndexOf('"');
            nameFromResponse = headerLine.substring(startFileNameIndex, endFileNameIndex);
          }

          fileName = nameFromResponse;
          _context3.next = 35;
          return response.blob();

        case 35:
          data = _context3.sent;

          // Send downloaded data to browser
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(data, fileName);
          } else {
            _url = window.URL.createObjectURL(data);
            link = document.createElement('a');
            link.href = _url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          } // Close modal


          _context3.next = 39;
          return (0, _effects.put)(modalActions.close());

        case 39:
          _context3.next = 41;
          return (0, _effects.put)(actions.success());

        case 41:
          _context3.next = 54;
          break;

        case 43:
          _context3.prev = 43;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 47;
          return (0, _effects.select)(_selectors2.getIsAborted);

        case 47:
          isAborted = _context3.sent;

          if (isAborted) {
            _context3.next = 54;
            break;
          }

          console.error(_context3.t0);
          _context3.next = 52;
          return (0, _effects.put)(modalActions.show("error/errorMessage", _context3.t0.message, _modalTypes.MODAL_TYPES.ERROR));

        case 52:
          _context3.next = 54;
          return (0, _effects.put)(actions.failure());

        case 54:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 43]]);
}

function asyncDownloadWatcher() {
  return regeneratorRuntime.wrap(function asyncDownloadWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, downloadWorker);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeEvery)(types.SAGA_STATUS, checkDownloadStatus);

        case 4:
          _context4.next = 6;
          return (0, _effects.takeEvery)(modalTypes.CLOSE, abortDownload);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}